module.exports = __webpack_public_path__ + "images/f3e6623.svg";